module.exports = __webpack_public_path__ + "img/4／1.469f64a5.png";